import { Directive, inject, input, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, filter, switchMap } from 'rxjs';
import { FormPickerComponent } from '@core/components';
import { RequestsApiService } from '@core/services/request/requests-api.service';

/**
 * Источник специалистов для модалки назначения СЛС.
 * Берёт список из api2 (должность «установщик» + registryPersonSubdivisionRelation) —
 * тот же источник, по которому бэкенд проверяет назначение, как в реестре ТМЛ.
 * Legacy xAttachInstallers (logisticRequestInstallersList) с ним расходится и давал
 * 400 «Установщик не найден» на сохранении.
 */
@Directive({
  selector: 'x-form-picker[xAttachAssignmentInstallers]',
})
export class AttachAssignmentInstallersDirective implements OnInit {
  private readonly requestsApiService = inject(RequestsApiService);
  private readonly component = inject(FormPickerComponent);

  readonly $contractorId = input.required<number>({
    alias: 'contractorId',
  });
  readonly $contractorSubdivisionId = input.required<number>({
    alias: 'contractorSubdivisionId',
  });
  readonly contractorId$ = toObservable(this.$contractorId);
  readonly contractorSubdivisionId$ = toObservable(
    this.$contractorSubdivisionId,
  );

  ngOnInit(): void {
    this.component.items$ = combineLatest([
      this.contractorId$,
      this.contractorSubdivisionId$,
    ]).pipe(
      filter(ids => ids.every(Boolean)),
      switchMap(
        ([contractorCounterpartyId, contractorCounterpartySubdivisionId]) =>
          this.requestsApiService.getAssignmentInstallers$({
            contractorCounterpartyId,
            contractorCounterpartySubdivisionId,
          }),
      ),
    );
  }
}
